import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=21ced943&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ced943')) {
      api.createRecord('21ced943', component.options)
    } else {
      api.reload('21ced943', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=21ced943&", function () {
      api.rerender('21ced943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wla/Summary.vue"
export default component.exports